import { render } from "./LangueWrapper.vue?vue&type=template&id=15748d80"
import script from "./LangueWrapper.vue?vue&type=script&lang=js"
export * from "./LangueWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__